import {SponsorHeaderProps} from './type';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useNavigate} from 'react-router-dom';

const SponsorHeader = ({title}: SponsorHeaderProps) => {
  const navigate = useNavigate();
  return (
    <header className="shadow-md p-[18px] text-md text-gray-800 shrink-0">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <SpanIcon
            className="icon-nameArrow---Right text-[20px]"
            onClick={() => navigate('/my-store-info')}
          />
          <span>{title}</span>
        </div>
      </div>
    </header>
  );
};

export default SponsorHeader;
